"use client"

import React from "react";
import { useRouter } from "next/navigation";
import { ArrowLeft, FileQuestion } from "lucide-react";

export default function NotFound() {
    const router = useRouter();
    return (
        <div className="flex flex-col mx-auto items-center justify-center min-h-screen bg-gradient-to-b from-background to-background/80 p-4">
            <div className="w-full max-w-md bg-card rounded-xl shadow-2xl p-8 border border-border/50">
                <div className="flex flex-col items-center text-center">
                    <div className="w-20 h-20 bg-destructive/10 rounded-full flex items-center justify-center mb-6">
                        <FileQuestion className="w-10 h-10 text-destructive animate-pulse" />
                    </div>
                    
                    <h1 className="text-3xl font-bold mb-2 bg-gradient-to-r from-foreground to-foreground/70 bg-clip-text text-transparent">
                        Page Not Found
                    </h1>
                    
                    <p className="text-muted-foreground mb-6">
                        The page you&apos;re looking for doesn&apos;t exist or has been moved. Please check the URL or return to the previous page.
                    </p>

                    <div className="flex flex-col sm:flex-row gap-4 w-full">
                        <button 
                            type="button"
                            aria-label="Go back"
                            onClick={() => router.back()}
                            className="flex-1 bg-primary hover:bg-primary/90 text-primary-foreground p-3 rounded-lg flex items-center justify-center gap-2 transition-all duration-300 font-medium"
                        >
                            <ArrowLeft className="w-4 h-4" />
                            <span>Return Back</span>
                        </button>
                    </div>

                    <p className="text-xs text-muted-foreground mt-6">
                        Error Code: 404
                    </p>
                </div>
            </div>
        </div>
    )
}
